@use '../../../common/styles/variables' as *;

:host {
  display: inline-flex;
  @include default-css-variables;
}

.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.info-icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  transition: opacity 0.2s ease-in-out;
  border-radius: 2px;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid var(--nylas-primary-500, #2563eb);
    outline-offset: 2px;
    border-radius: 2px;
  }

  &[aria-pressed='true'] {
    opacity: 1;
    background-color: var(--nylas-primary-50, rgba(37, 99, 235, 0.1));
    border-radius: 4px;
  }
}

// Hidden tooltip content for accessibility (actual tooltip rendered in portal)
.tooltip-content {
  // This element is visually hidden but available for ARIA
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
